import { useConfirmStore } from '@/stores/feedback';
import { useEditorEvent } from '@/editor-hooks/useEditorEvent';
import { EditorEventName } from '@/editor/event/editorEvent';
import { useInModal } from '@/editor-hooks/useKeyboardController';
import { ConfirmDialog } from './confirm-dialog';
import { handleEditorConfirm, settleConfirm } from './confirm-service';

export const ConfirmRenderer = () => {
  // 队首即当前展示的确认框，其余排队等候
  const entry = useConfirmStore((state) => state.queue[0]);
  const isOpen = entry !== undefined;

  useEditorEvent(EditorEventName.FEEDBACK_CONFIRM, handleEditorConfirm);

  useInModal(isOpen);

  return (
    <ConfirmDialog
      open={isOpen}
      title={entry?.contentTitle}
      content={entry?.content}
      confirmText={entry?.confirmText}
      cancelText={entry?.cancelText}
      hideCancel={entry?.hideCancel}
      danger={entry?.danger}
      boxed={entry?.boxed}
      onConfirm={() => {
        if (entry) settleConfirm(entry.id, true);
      }}
      onCancel={() => {
        if (entry) settleConfirm(entry.id, false);
      }}
    />
  );
};
